const pagesIndividualPlacesEn = {
  detail: {
    tabs: {
      devices: 'Devices',
      equipments: 'Equipment'
    }
  },
  headers: {
    deviceCount: 'Devices',
    equipmentCount: 'Equipment',
    location: 'Location',
    name: 'Place',
    responsiblePerson: 'Responsible person'
  },
  pageTitle: 'Places',
  tabs: {
    managedPlace: 'Sites I manage'
  }
};
export default pagesIndividualPlacesEn;